import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';

import Heading from 'components/shared/heading';
import AppButton from 'components/shared/app-button';
import Logo from 'images/logo.inline.svg';
import { handleAppRedirectClick, isIOS, isAndroid, isIOSSafari } from 'utils/app-redirect';

import shape from './images/shape.svg';
import styles from './styles.module.scss';

const OpenMobileApp = ({
  title = '',
  description = '',
  desktopLandingUrl = '',
  autoRedirectOnMobile = true,
}) => {
  const [platform, setPlatform] = useState('unknown');
  const {
    wp: {
      globalFields: {
        acf: { appStoreUrl, googlePlayUrl },
      },
    },
  } = useStaticQuery(graphql`
    {
      wp {
        globalFields {
          acf {
            appStoreUrl
            googlePlayUrl
          }
        }
      }
    }
  `);

  useEffect(() => {
    setPlatform(isIOS() ? 'ios' : isAndroid() ? 'android' : 'desktop');
  }, []);

  useEffect(() => {
    if (!autoRedirectOnMobile || !appStoreUrl || !googlePlayUrl) return;
    const shouldAutoRedirect = platform === 'android' || (platform === 'ios' && !isIOSSafari());

    if (shouldAutoRedirect) {
      handleAppRedirectClick({
        appStoreUrl,
        googlePlayUrl,
        desktopUrl: desktopLandingUrl,
      });
    }
  }, [autoRedirectOnMobile, platform, appStoreUrl, googlePlayUrl, desktopLandingUrl]);

  return (
    <section className={styles.appDetails}>
      <div className="container">
        <div className={styles.content}>
          <div className={styles.logoWrapper}>
            <Logo className={styles.logo} />
          </div>
          {title && (
            <Heading className={styles.title} tag="h2" size="xl">
              {title}
            </Heading>
          )}
          {description && (
            <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
          )}
          {platform === 'desktop' && <div className={styles.separator}>download app from</div>}
          {platform !== 'unknown' && (
            <div className={styles.buttonsWrapper}>
              {platform === 'desktop' && (
                <>
                  <AppButton className={styles.button} type="appStore" href={appStoreUrl} />
                  <AppButton className={styles.button} type="googlePlay" href={googlePlayUrl} />
                </>
              )}
              {platform === 'ios' && (
                <AppButton className={styles.button} type="appStore" href={appStoreUrl} />
              )}
              {platform === 'android' && (
                <AppButton className={styles.button} type="googlePlay" href={googlePlayUrl} />
              )}
            </div>
          )}
        </div>
        <img className={styles.shape} src={shape} alt="" loading="lazy" aria-hidden />
      </div>
    </section>
  );
};

OpenMobileApp.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  showStoreButtons: PropTypes.bool,
  desktopLandingUrl: PropTypes.string,
  autoRedirectOnMobile: PropTypes.bool,
};

export default OpenMobileApp;
